import * as React from 'react';
import { useTranslation } from 'react-i18next';
import '../ledger/TreeLedger.scss';
import './TreeLedgerHeader.scss';

/** The orders the rows can be in; only the effective date has a heading. */
export type TreeLedgerSort = 'name' | 'effective';

export type TreeLedgerHeaderProps = {
  /** The order the rows are in, marked on its heading. */
  sort?: TreeLedgerSort;
  /** Called with the order a heading asks for; without it nothing sorts. */
  onSort?: (sort: TreeLedgerSort) => void;
};

/**
 * Column headings for the explorer's ledger. Render it inside the tree's
 * scroll container, just above the tree: it sticks to the top as the rows
 * scroll under it, and it shares their grid, so each heading sits over its
 * column. The name, and the row actions after the date, go unheaded. A narrow
 * explorer drops it. The File heading shows only where the host turns its
 * column on.
 */
export const TreeLedgerHeader: React.FC<TreeLedgerHeaderProps> = ({
  sort,
  onSort,
}) => {
  const { t } = useTranslation();

  const effective = t('Effective');
  const sorted = sort === 'effective';

  return (
    <div className="tree-ledger-head">
      <div className="tree-ledger-cell tree-ledger-cell--file">{t('File')}</div>
      <div className="tree-ledger-cell tree-ledger-cell--party-a">
        {t('Party {{letter}}', { letter: 'A' })}
      </div>
      <div className="tree-ledger-cell tree-ledger-cell--party-b">
        {t('Party {{letter}}', { letter: 'B' })}
      </div>
      <div className="tree-ledger-cell tree-ledger-cell--effective">
        {onSort ? (
          <button
            type="button"
            className={sorted ? 'sorted' : undefined}
            aria-sort={sorted ? 'ascending' : 'none'}
            onClick={() => onSort('effective')}
          >
            {effective}
          </button>
        ) : (
          effective
        )}
      </div>
      <div className="tree-ledger-cell tree-ledger-cell--alerts">
        {t('Alerts')}
      </div>
    </div>
  );
};
